import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "top"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "head" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("BotManager")
const _hoisted_8 = { class: "nav" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "edit", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("単語編集 ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "history_edu", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("お題編集 ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "lightbulb", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("お試し ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "chair", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("部屋 ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "settings", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("設定 ")
const _hoisted_19 = { class: "main" }
const _hoisted_20 = {
  key: 1,
  class: "center"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "dot-pulse" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_ctx.state.show && !_ctx.wordLoading && !_ctx.categoryLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.hamOpen = !_ctx.state.hamOpen)),
          class: _normalizeClass(['ham', _ctx.state.hamOpen ? 'ham-open' : ''])
        }, _hoisted_5, 2),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _createElementVNode("nav", {
              class: _normalizeClass([_ctx.state.hamOpen ? 'open' : ''])
            }, [
              _createElementVNode("h1", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: "/bot/",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.hamOpen = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("ul", _hoisted_8, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/bot/word",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.hamOpen = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/bot/theme",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.hamOpen = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11,
                      _hoisted_12
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/bot/test",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.hamOpen=false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/bot/room",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.hamOpen = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15,
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/bot/setting",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.hamOpen = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17,
                      _hoisted_18
                    ]),
                    _: 1
                  })
                ])
              ])
            ], 2)
          ]),
          _: 1
        }),
        (_ctx.state.hamOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "close",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.hamOpen = false))
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ route, Component }) => [
              _createVNode(_Transition, {
                name: "bot",
                appear: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_KeepAlive, null, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                      class: "bot",
                      key: route.fullPath
                    }))
                  ], 1024))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
}